import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast, Toaster } from "sonner";

const AdminLogin = () => {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Bienvenido");
      navigate("/admin");
    } catch (err) {
      const detail = err.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Error al iniciar sesión");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-6" data-testid="admin-login">
      <Toaster richColors position="top-center" />
      <div className="w-full max-w-sm">
        <p className="overline text-center mb-4">Acceso Administrador</p>
        <h1 className="font-display text-3xl text-center mb-10">Consola AQ Watches</h1>
        <form onSubmit={submit} className="space-y-2">
          <input
            className="aq-input"
            placeholder="Correo (uso interno)"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            data-testid="login-email"
          />
          <input
            className="aq-input"
            placeholder="Contraseña"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            data-testid="login-password"
          />
          <div className="pt-6">
            <button type="submit" disabled={loading} data-testid="login-submit" className="btn-primary w-full disabled:opacity-60">
              {loading ? "Ingresando…" : "Iniciar Sesión"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
